/* eslint new-cap: 0 */
/**
 * WARNING. DANGER.
 * STOP!
 * THIS FILE IS DEPRECATED.
 * Do not add to this file
 * it will be deleted in the near future.
 * Add new routes to client/AdminPortal/router/Routes.js
 */
const Constants = require('client/util/Constants').default;
const DirectoryDialogsHelper = require('client/directories/DirectoryDialogsHelper').default;
const EventHelper = require('client/GrowthEngineering/EventHelper').default;
const EventManager = require('client/GrowthEngineering/EventManager').default;
const GetApplicationType = require('client/util/GetApplicationType').default;
const GlobalEventBus = require('client/EventBus/GlobalEventBus').default;
const globalRouteService = require('client/AdminPortal/router/globalRouteService').default;
const JobUtils = require('client/util/JobUtils').default;
const LocalStorageService = require('client/util/LocalStorageService').default;
const ModalControl = require('client/components/Modal/views/Modal');
const OptimizelyHelper = require('client/GrowthEngineering/OptimizelyHelper').default;
const PageNavigationUtil = require('client/util/PageNavigationUtil').default;
const util = require('client/util');
const LoggingService = require('client/util/LoggingService').default;
const { PROVISION_STATUS_AUTHORIZED } = require('client/util/Constants/ApplicationConstants');
const {
  DirectoryActionConsts,
  DirectoryNameConsts,
  DirectoryTypeConsts,
  ItemActionConsts,
  ItemTypeConsts,
  ItemTypeRoutes,
  LocalStorageConsts,
} = require('client/util/Constants');
const {
  AdBridgeAsidePanelWrapper,
  ApplicationAsidePanelWrapper,
  ApplicationChooserAsidePanelWrapper,
  ApplicationMainPanelWrapper,
  AuthNPoliciesMainPanelWrapper,
  AuthNPoliciesSettingsWrapper,
  ConfigurationGroupAsidePanelWrapper,
  DirectoriesMainPanelWrapper,
  GSuiteAsidePanelWrapper,
  GroupsMainPanelWrapper,
  MdmSettingsMainPanelWrapper,
  ReportsMainPanelWrapper,
  O365AsidePanelWrapper,
  SystemGroupAsidePanelWrapper,
  WorkdayAsidePanelWrapper,
} = require('client/components/VueComponentWrappers');
const { capitalize } = require('lodash');
const { eventProperties } = require('client/GrowthEngineering/utilities/GrowthConstants');

const {
  toUrl,
} = eventProperties;

// Just put these here for now; this file will be going away
const RouteConsts = {
  activeDirectory: 'active-directory',
  appAuthorization: 'appAuthorization',
  application: 'applications',
  authnpoliciesSettings: 'authnpoliciesSettings',
  cloudDirectories: 'cloud-directories',
  commands: 'commands',
  configuration: 'configurations',
  device: 'devices',
  directories: 'directories',
  hrDirectories: 'hr-directories',
  insights: 'insights',
  gettingstarted: 'gettingstarted',
  groups: 'groups',
  ldap: 'ldap',
  managedSoftware: 'managedSoftware',
  mdm: 'mdm',
  notification: 'notifications',
  policy: 'policies',
  radius: 'radius',
  security: 'security',
  settings: 'settings',
  settingsGeneral: 'settingsGeneral',
  settingsMfa: 'settingsMFA',
  settingsSecurity: 'settingsSecurity',
  sso: 'sso',
  support: 'support',
  system: 'systems',
  systemUser: 'users',
};

const createConfigurationGroupAsidePanel = () => ({
  AsidePanelWrapper: ConfigurationGroupAsidePanelWrapper,
  asidePanelProps: {
    itemType: ItemTypeConsts.configurationGroup,
  },
});

const createSystemGroupAsidePanel = () => ({
  AsidePanelWrapper: SystemGroupAsidePanelWrapper,
  asidePanelProps: {
    itemType: ItemTypeConsts.deviceGroup,
  },
});

module.exports = Backbone.Router.extend({
  // Variables to keep track of which panel is active
  mainPanel: null,
  asidePanel: null,

  routes: {
    'applications/:id/details': 'redirectLegacyRoute',
    'applications/:id/provision/:status': 'redirectLegacyRoute',
    'applications/choose': 'redirectLegacyRoute',
    'applications/configure/:templateId': 'redirectLegacyRoute',
    'sso/:id/details': 'showApplicationDetails',
    'sso/:id/provision/:status': 'showApplicationDetails',
    'sso/choose': 'showApplicationChooser',
    'sso/configure/:templateId': 'showApplicationConfigure',
    'directories/active-directory/(:id)/(:action)': 'showActiveDirectories',
    'directories/hr-directories/(:type)(/:id)/(:action)': 'showHrDirectories',
    'directories/:type(/:id)/:action': 'showDirectories',
    'directories/:type': 'showDirectoryPanel',
    'groups/:type/:id/details': 'showGroups',
    'groups/:type/:action': 'showGroups',
    'groups/:type/membership/suggested/updates': 'showGroups',
    'groups/:type': 'showGroups',
    'mtp/*path': 'showMtp',
    'policies/choose(/:os)': 'redirectLegacyRoute',
    'policies/configure/:os/:templateId': 'redirectLegacyRoute',
    'users/jobs/:id/importResults': 'showUserImportJobResults',
    'users/jobs/:id/updateResults': 'showUserUpdateJobResults',
    'users/add/:initialTab': 'showInitialTab',
    'users/:id/details/:initialTab': 'showInitialTab',

    // Phasing add out (moving toward /new)
    '*action/add': 'showDetails',
    '*action(/:type)/new': 'showDetails',

    '*action(/:type)/:id/details': 'showDetails',

    '*action': 'default',
  },

  initialize(options) {
    LoggingService.debug('Router.initialize');

    this.bind('route', this.pageView);

    this.viewport = options.viewport;
    this.globalRouteService = options.globalRouteService != null
      ? options.globalRouteService
      : globalRouteService;
  },

  /**
   * If a Panel is open, check if there are unsaved changes made to the
   * model, and its associated resources, allowing the caller to warn the admin
   * user that their unsaved changes will be lost if they're not saved prior to
   * leaving the page.
   */
  hasModelChanged() {
    if (this.asidePanel && typeof this.asidePanel.hasModelChanged === 'function') {
      return this.asidePanel.hasModelChanged();
    }

    if (this.mainPanel && typeof this.mainPanel.hasModelChanged === 'function') {
      return this.mainPanel.hasModelChanged();
    }

    return false;
  },

  isModelProcessing() {
    if (this.asidePanel && typeof this.asidePanel.isModelProcessing === 'function') {
      return this.asidePanel.isModelProcessing();
    }

    return false;
  },

  getModelProcessingData() {
    if (this.asidePanel && typeof this.asidePanel.getModelProcessingData === 'function') {
      return this.asidePanel.getModelProcessingData();
    }

    return null;
  },

  pageView() {
    const path = Backbone.history.getFragment();

    util.ga('send', 'pageview', { page: `/${path}` });
    EventManager.handlePageVisited(path);
    EventHelper.triggerPageViewed({
      [toUrl]: `${window.location.hostname}/${path}`,
    });
    EventHelper.triggerLegacyRouterPathVisited({ path });
    GlobalEventBus.emitPageViewEvent(path);
  },

  redirectLegacyRoute() {
    const path = Backbone.history.getFragment();
    let redirectTo = '';

    if (path.match(/^applications/)) {
      redirectTo = path.replace(/^applications/, '#/sso');
    } else if (path === 'groups') {
      redirectTo = ItemTypeRoutes[ItemTypeConsts.userGroup];
    } else if (path.match(/^groups\/system/)) {
      redirectTo = path.replace(/^groups\/system/, '#/groups/device');
    } else if (path === 'directories') {
      redirectTo = ItemTypeRoutes[ItemTypeConsts.cloudDirectory];
    } else if (path.match(/^directories\/active_directory/)) {
      redirectTo = path.replace(/^directories\/active_directory/, '#/directories/active-directory');
    } else if (path.match(/^directories\/g_suite/)) {
      redirectTo = path.replace(/directories\/g_suite/, '#/directories/cloud-directories/g_suite');
    } else if (path.match(/^directories\/ldap_server/)) {
      redirectTo = path.replace(/^directories\/ldap_server/, '#/ldap');
    } else if (path.match(/^directories\/office_365/)) {
      redirectTo = path.replace(/^directories\/office_365/, '#/directories/cloud-directories/office_365');
    } else if (path.match(/^directories\/workday/)) {
      redirectTo = path.replace(/^directories\/workday/, '#/directories/hr-directories/workday');
    } else if (path.match(/^policies/)) {
      redirectTo = path.replace(/^policies/, '#/configurations');
    } else if (path.match(/^security/)) {
      redirectTo = ItemTypeRoutes[ItemTypeConsts.settingsSecurity];
    } else if (path === 'settings') {
      redirectTo = '#/settings/general';
    } else if (path.match(/^systems/)) {
      redirectTo = path.replace(/^systems/, '#/devices');
    }

    if (redirectTo) {
      const payload = {
        oldFragment: `#/${path}`,
        redirectTo,
        referrer: document ? document.referrer : '',
      };
      EventHelper.triggerLegacyPageRedirect(payload);

      this.navigate(redirectTo, { replace: true, trigger: true });
    }

    return redirectTo !== '';
  },

  showApplicationChooser() {
    const applicationOptions = { view: 'choose' };
    this.showApplicationAside(applicationOptions);
  },

  showApplicationAside(options) {
    const { sso } = ItemTypeConsts;
    const itemType = GetApplicationType(Backbone.history.getFragment());
    const applicationOptions = { itemType, ...options };
    const panelType = itemType === sso ? sso : 'applications';
    this.showPanel(panelType, applicationOptions);
  },

  showApplicationDetails(...params) {
    const [id, status] = params;
    let type;
    let options = {};

    const itemType = GetApplicationType(Backbone.history.getFragment());

    if (status) {
      switch (status) {
        case DirectoryActionConsts.activated:
          type = Constants.success;
          break;
        case DirectoryActionConsts.error:
          type = Constants.error;
          break;
        case PROVISION_STATUS_AUTHORIZED:
          type = PROVISION_STATUS_AUTHORIZED;
          break;
        default:
          type = null;
      }
      options = {
        itemType, type: null, modelId: id, provisionActivationStatus: type,
      };
    } else if (id) {
      options = { itemType, type: 'configure', modelId: id };
    }

    this.showApplicationAside(options);
  },

  showApplicationConfigure(id) {
    const itemType = GetApplicationType(Backbone.history.getFragment());
    const options = { itemType, type: 'configure', templateId: id };
    this.showApplicationAside(options);
  },

  showDetails(...params) {
    const [action, type, modelId] = params;

    if (this.redirectLegacyRoute()) {
      return;
    }

    switch (action) {
      case RouteConsts.directories:
      case RouteConsts.groups:
        this.showPanel(action, { type, modelId });
        break;
      default:
        this.showPanel(action, { modelId });
        break;
    }
  },

  showActiveDirectories(modelId, action) {
    const type = DirectoryTypeConsts.activeDirectory;
    const panelType = RouteConsts.activeDirectory;
    this.showDirectories(type, modelId, action, panelType);
  },

  showCloudDirectories(type, modelId, action) {
    const panelType = RouteConsts.cloudDirectories;
    this.showDirectories(type, modelId, action, panelType);
  },

  showCreateCloudDirectories(type, action) {
    this.showCloudDirectories(type, null, action);
  },

  showHrDirectories(type, modelId, action) {
    const panelType = RouteConsts.hrDirectories;
    this.showDirectories(type, modelId, action, panelType);
  },

  /**
   * @description Given the routes:
   *
   * /directories/:type/:id/activated
   * /directories/:type/:id/details
   * /directories/:type/:id/reactivated
   * /directories/:type/error
   *
   * Show the correct page
   *
   * @param {String} params.type - Directory type
   * @param {String} params.modelId - Directory ID (null on error)
   * @param {String} params.action - Requested action
   *   'activated':   Launch import tool and navigate to the aside for activated directory
   *   'details':     Navigate to the Directories aside
   *   'error':       Show an error message and return to Directories list
   *   'reactivated': Return to the Directories list
   * @param {String} params.panelType - If defined, type for directory details aside
   *
   */
  showDirectories(type, modelId, action, panelType) {
    const { activeDirectory, gSuite, office365 } = DirectoryTypeConsts;
    const oauthPanel = `directories/${RouteConsts.cloudDirectories}`;

    const directoryRoutes = [
      RouteConsts.activeDirectory,
      RouteConsts.cloudDirectories,
      RouteConsts.hrDirectories,
    ];

    let redirectAction = DirectoryActionConsts.details;

    if (this.redirectLegacyRoute()) {
      return;
    }

    switch (action) {
      case DirectoryActionConsts.activated:
        switch (type) {
          case gSuite:
          case office365:
            redirectAction = DirectoryActionConsts.import_users;
            break;
          default:
        }

        PageNavigationUtil.setLocationHash(`#/${oauthPanel}/${type}/${modelId}/${redirectAction}`);
        break;

      case DirectoryActionConsts.error:
        util.notify(
          Constants.error,
          `Unable to perform the requested action for the ${DirectoryNameConsts[type]} Directory.`,
        );
        PageNavigationUtil.setLocationHash(`#/${oauthPanel}`);
        break;

      case DirectoryActionConsts.reactivated:
        util.notify(
          Constants.success,
          `The ${DirectoryNameConsts[type]} Directory was successfully ${DirectoryActionConsts.reactivated}.`,
        );
        PageNavigationUtil.setLocationHash(`#/${oauthPanel}/${type}/${modelId}/details`);
        LocalStorageService.setItem('reactivated', true);
        break;

      case DirectoryActionConsts.create:
        switch (type) {
          case activeDirectory:
            DirectoryDialogsHelper.showCreateActiveDirectoryDirectoryDialog();
            break;
          case gSuite:
            DirectoryDialogsHelper.showCreateGSuiteDirectoryDialog();
            break;
          case office365:
            DirectoryDialogsHelper.showCreateO365DirectoryDialog();
            break;
          default: // do nothing
        }

        if (type === DirectoryTypeConsts.activeDirectory) {
          PageNavigationUtil.setLocationHash(`#/${RouteConsts.activeDirectory}`);
        } else {
          PageNavigationUtil.setLocationHash(`#/${oauthPanel}`);
        }

        break;

      case DirectoryActionConsts.import_users:
        switch (type) {
          case gSuite:
          case office365:
            DirectoryDialogsHelper.showDirectoryImportUsersModal(type, modelId);
            break;
          default:
            break;
        }

        this.showDirectories(type, modelId, DirectoryActionConsts.details, panelType);
        break;

      case DirectoryActionConsts.details:
      default:
        /**
         * This check is necessary to ensure admin email for expiring tokens works
         * for both provider and non-provider admins
         * @see https://jumpcloud.atlassian.net/browse/DE-1152
         */
        if (panelType && directoryRoutes.includes(panelType)) {
          this.showPanel(panelType, { type, modelId });
        } else {
          // Handle old nav directory details navigation
          this.showPanel(RouteConsts.directories, { type, modelId });
        }
    }
  },

  /**
   * This method handles the following routes:
   *
   * #/directories/active-directory
   * #/directories/cloud-directories
   * #/directories/hr-directories
   *
   * It navigates to the directories main panel to show only the specific directory types:
   *
   * - active-directory shows only Active Directory Domains
   * - cloud-directories shows G Suite and Microsoft 365
   * - cloud-directories shows Google Workspace and Microsoft 365
   * - hr-directories shows Workday
   */
  showDirectoryPanel(type) {
    this.showPanel(type);
  },

  /**
   * This method is called for the following routes:
   *
   * #/groups/:type/:id/details
   * #/groups/:type/:action
   * #/groups/:type
   *
   * For the first two routes, aside panel options are passed to the showPanel() method to display
   * the appropriate aside panel. Note that in additiona to the standard type and modelId, the
   * panelType is passed as the itemType to the aside panel. This is done so that the group aside
   * panel knows when it is being rendered for a device group, so that the appropriate labeling can
   * be done.
   *
   * For the last route, the appropriate main panel is opened.
   */
  showGroups(...params) {
    if (this.globalRouteService.isVueRoute()) {
      LoggingService.error('DualRouter: Invalid Code Path Router.showGroups on Vue Route');
      return;
    }

    const path = Backbone.history.getFragment();
    const [groupType, modelIdOrAction] = params;
    const {
      configuration,
      configurationGroup,
      device,
      deviceGroup,
      system,
      user,
      userGroup,
    } = ItemTypeConsts;

    let itemType;
    let panelType;
    let type;

    if (path.match(/^groups\/user\/membership\/suggested\/updates/)) {
      LocalStorageService.setItem(LocalStorageConsts.membershipFiltersEnabled, true);
    }

    if (this.redirectLegacyRoute()) {
      return;
    }

    if (groupType === device) {
      itemType = deviceGroup;
      panelType = deviceGroup;
      type = system;
    } else if (groupType === user) {
      itemType = userGroup;
      panelType = userGroup;
      type = user;
    } else if (groupType === configuration) {
      itemType = configurationGroup;
      panelType = configurationGroup;
      type = configuration;
    }

    let asideOptions;

    if (modelIdOrAction) {
      asideOptions = { type, itemType };

      if (modelIdOrAction !== 'new') {
        asideOptions.modelId = modelIdOrAction;
      }
    }

    this.showPanel(panelType, asideOptions);
  },

  showMtp() {
    // eslint-disable-next-line global-require
    const InitializationHandler = require('client/util/InitializationHandler').default;
    InitializationHandler.clearAdminPortal();
    InitializationHandler.initializeMtp();
  },

  showInitialTab(...params) {
    const [id, initialTab] = params;

    let navigateToTab;
    let modelId;

    if (!initialTab) {
      navigateToTab = { tabLabel: capitalize(id) };
    } else {
      navigateToTab = { tabLabel: capitalize(initialTab) };
      modelId = id;
    }

    this.showPanel('users', {
      modelId,
      navigateToTab,
      itemType: ItemTypeConsts.systemUser,
    });
  },

  showUserImportJobResults(id) {
    this.showJobResults(id, ItemTypeConsts.systemUser, ItemActionConsts.create);
  },

  showUserUpdateJobResults(id) {
    this.showJobResults(id, ItemTypeConsts.systemUser, ItemActionConsts.update);
  },

  /**
   * The job results page displays the appropriate main panel and opens a modal
   * dialog that allows the user to download the results of their Bulk or
   * Workday import.
   *
   * Note that the import results are retrieved _first_, before enabling the
   * action button in the dialog, because clicking the action button opens a
   * new window and if that's done asynchronously, i.e. in the response handler
   * of an XHR request, then the browser's popup blocker will be triggered. To
   * avoid this, we obtain the data _first_, and then enable the button, so
   * that opening a new window is done in the onclick handler which does _not_
   * trigger the browser's popup blocker.
   */
  showJobResults(id, type, actionType) {
    let importedUsers;
    let panel;
    let title;

    if (type === DirectoryTypeConsts.workday) {
      panel = RouteConsts.directories;
      title = 'Workday';
    } else {
      panel = 'users';
      title = 'Bulk';
    }

    const actionName = actionType === ItemActionConsts.update ? 'Update' : 'Import';

    this.showPanel(panel);

    this.modal = new ModalControl({
      loading: true,
      viewport: this.viewport,
      width: 600,
      title: `${title} ${actionName} Results`,
      content: [
        '<p>',
        `Click the download button below to view the results of your ${title} ${actionName}.`,
        '</p>',
      ].join(''),
      button: {
        color: 'green', text: 'Download',
      },
      buttonEvent: () => {
        this.modal.hide().then(() => delete this.modal);
        JobUtils.downloadCsv(id, importedUsers, type, actionType);
      },
    }).render();

    JobUtils
      .getImportResults(id, type)
      .then((data) => {
        importedUsers = data;
        this.modal.set('loading', false);
      })
      .catch(() => {
        this.modal.hide().then(() => delete this.modal);
        util.notify(Constants.error, `Unable to get the results of your ${title} ${actionName}!`);
      });
  },

  // Go to the root page (ignoring and removing anything unrecognized after that)
  default(action) {
    LoggingService.debug('Router.default');
    if (this.globalRouteService.isVueRoute()) {
      LoggingService.debug('Router.default isVueRoute');
      LoggingService.error('DualRouter: Invalid Code Path Router.default on Vue Route');
      this.viewport.closeAside();
      return;
    }

    if (this.redirectLegacyRoute()) {
      return;
    }

    if (action) {
      const [fragment] = action.split('/');
      this.navigate(fragment, { replace: true });
    }

    this.showPanel(action);
  },

  /**
   * @description Object containing main panel classes mapped to the route they belong to.
   * Each route has a class which is the view that will be rendered for the main
   * panel. You may also specify an options function which should replace the default
   * object passed to the class constructor. See createAsidePanel.groups.options
   * for a usage of the options specification
   */
  createMainPanel: {
    [RouteConsts.activeDirectory]: {
      action: RouteConsts.activeDirectory,
      gettingStartedPanelItemType: ItemTypeConsts.activeDirectory,
      itemType: ItemTypeConsts.activeDirectory,
      MainPanelWrapper: DirectoriesMainPanelWrapper,
      title: 'Active Directory Integration',
    },
    [RouteConsts.cloudDirectories]: {
      action: RouteConsts.cloudDirectories,
      gettingStartedPanelItemType: ItemTypeConsts.cloudDirectory,
      itemType: ItemTypeConsts.cloudDirectory,
      MainPanelWrapper: DirectoriesMainPanelWrapper,
      title: 'Cloud Directory Integrations',
    },
    [RouteConsts.hrDirectories]: {
      action: RouteConsts.hrDirectories,
      gettingStartedPanelItemType: ItemTypeConsts.hrDirectory,
      itemType: ItemTypeConsts.hrDirectory,
      MainPanelWrapper: DirectoriesMainPanelWrapper,
      title: 'HR Directory Integrations',
    },
    authnpolicies: {
      action: 'authnpolicies',
      MainPanelWrapper: AuthNPoliciesMainPanelWrapper,
      title: 'Conditional Access Policies',
    },
    [RouteConsts.authnpoliciesSettings]: {
      action: RouteConsts.authnpoliciesSettings,
      MainPanelWrapper: AuthNPoliciesSettingsWrapper,
      title: 'Conditional Access Policies',
    },
    [ItemTypeConsts.configurationGroup]: {
      action: ItemTypeConsts.configurationGroup,
      gettingStartedPanelItemType: ItemTypeConsts.configurationGroup,
      itemType: ItemTypeConsts.configurationGroup,
      MainPanelWrapper: GroupsMainPanelWrapper,
      title: 'Policy Groups',
    },
    [ItemTypeConsts.deviceGroup]: {
      action: ItemTypeConsts.deviceGroup,
      gettingStartedPanelItemType: ItemTypeConsts.deviceGroup,
      itemType: ItemTypeConsts.deviceGroup,
      MainPanelWrapper: GroupsMainPanelWrapper,
      title: 'Device Groups',
    },
    // converted to vueRouter in MdmRoutes.js
    mdm: {
      action: RouteConsts.mdm,
      itemType: ItemTypeConsts.mdmSettings,
      gettingStartedPanelItemType: ItemTypeConsts.mdmSettings,
      MainPanelWrapper: MdmSettingsMainPanelWrapper,
      title: 'MDM',
    },
    reports: {
      action: 'reports',
      itemType: ItemTypeConsts.reports,
      MainPanelWrapper: ReportsMainPanelWrapper,
      title: 'Reports',
    },
    sso: {
      action: RouteConsts.sso,
      gettingStartedPanelItemType: ItemTypeConsts.sso,
      itemType: ItemTypeConsts.application,
      MainPanelWrapper: ApplicationMainPanelWrapper,
      title: 'SSO',
    },
    [ItemTypeConsts.userGroup]: {
      action: ItemTypeConsts.userGroup,
      gettingStartedPanelItemType: ItemTypeConsts.userGroup,
      itemType: ItemTypeConsts.userGroup,
      MainPanelWrapper: GroupsMainPanelWrapper,
      title: 'User Groups',
    },
  },

  /**
   * @description Object containing aside panel classes mapped to the route they belong to.
   * Each route has a class which is the view that will be rendered for the aside
   * panel. You may also specify an options function which should replace the default
   * object passed to the class constructor.
   */
  createAsidePanel: {
    [RouteConsts.cloudDirectories]: {
      g_suite: {
        AsidePanelWrapper: GSuiteAsidePanelWrapper,
      },
      office_365: {
        AsidePanelWrapper: O365AsidePanelWrapper,
      },
    },
    [RouteConsts.activeDirectory]: {
      AsidePanelWrapper: AdBridgeAsidePanelWrapper,
      asidePanelProps: {
        itemType: ItemTypeConsts.activeDirectory,
      },
    },
    [RouteConsts.hrDirectories]: {
      workday: {
        AsidePanelWrapper: WorkdayAsidePanelWrapper,
        asidePanelProps: {
          itemType: ItemTypeConsts.workday,
        },
      },
    },
    directories: {
      options(self, asideOptions) {
        return {
          modelId: asideOptions && asideOptions.modelId,
          type: asideOptions && asideOptions.type,
          viewport: self.viewport,
        };
      },
      active_directory: {
        AsidePanelWrapper: AdBridgeAsidePanelWrapper,
      },
      g_suite: {
        AsidePanelWrapper: GSuiteAsidePanelWrapper,
      },
      office_365: {
        AsidePanelWrapper: O365AsidePanelWrapper,
      },
      workday: {
        AsidePanelWrapper: WorkdayAsidePanelWrapper,
      },
    },

    [ItemTypeConsts.configurationGroup]: createConfigurationGroupAsidePanel(),
    [ItemTypeConsts.deviceGroup]: createSystemGroupAsidePanel(),

    sso: {
      AsidePanelWrapper: ApplicationAsidePanelWrapper,

      options(self, asideOptions) {
        return {
          itemId: asideOptions && asideOptions.modelId,
          provisionActivationStatus: asideOptions && asideOptions.provisionActivationStatus,
          itemType: ItemTypeConsts.sso,
        };
      },

      choose: {
        // HACK: Create new "class" so that the element can be passed to the VueComponentWrapper
        // constructor.
        className: function createApplicationChooserAsidePanel(data) {
          return new ApplicationChooserAsidePanelWrapper('aside', data);
        },

        options(self, asideOptions) {
          return {
            itemType: asideOptions && asideOptions.itemType,
            modelId: asideOptions && asideOptions.modelId,
            viewport: self.viewport,
          };
        },
      },

      configure: {
        AsidePanelWrapper: ApplicationAsidePanelWrapper,
        asidePanelProps: {
          itemType: ItemTypeConsts.sso,
        },
      },
    },
  },

  getLandingPageRoute() {
    let route;
    if (OptimizelyHelper.shouldShowHomeAsLandingPage()) {
      route = '#/home';
    } else {
      route = '#/users';
    }
    return route;
  },

  showPanel(page, asideOptions) {
    // showPanel isn't run on Vue routes, this is just a safety net
    if (this.globalRouteService.isVueRoute()) {
      LoggingService.error('DualRouter: Invalid Code Path Router.showPanel on Vue Route');
      return;
    }

    // First - handle redirects

    // If we don't have a page, go to the Users panel
    if (!page) {
      this.viewport.redirect(this.getLandingPageRoute());
      return;
    }

    // Next - create main and/or aside panels

    // The following two variables keep track of what panel
    let createMainPanel = false;
    let createAsidePanel = false;
    // If we're not on the page's main panel, we need to render it
    if (this.viewport.getMainPanelAction() !== page && this.createMainPanel[page]) {
      // create the main panel
      createMainPanel = true;
      // check if there is a main panel option
      const mainPanelCustomOptions = this.createMainPanel[page].options;
      // if there is not an option set it to the default
      const mainPanelOptions = mainPanelCustomOptions
        ? mainPanelCustomOptions(this) : { viewport: this.viewport };

      if (this.createMainPanel[page].MainPanelWrapper) {
        // Render main panel as a Vue component if there is a wrapper available
        const mainPanelPage = this.createMainPanel[page];
        $('#backbone').empty().append('<div id="main-panel"></div>');
        this.mainPanelProps = {
          gettingStartedPanelItemType: mainPanelPage.gettingStartedPanelItemType,
          itemType: mainPanelPage.itemType,
          isAsideOpen: false,
          selectedModelId: '',
          setSelectedModelId: (selectedModelId) => {
            this.mainPanelProps.selectedModelId = selectedModelId;
          },
          viewport: this.viewport,
        };
        this.mainPanel = new mainPanelPage.MainPanelWrapper('#main-panel', this.mainPanelProps);
        /**
         * The properties below are attached directly to `mainPanel` to provide compatibility for
         * the new Vue component to work with old Viewport.js code
         */
        this.mainPanel.action = mainPanelPage.action;
        this.mainPanel.gettingStartedPanelItemType = mainPanelPage.gettingStartedPanelItemType;
        this.mainPanel.itemType = mainPanelPage.itemType;
        this.mainPanel.setSelectedModelId = this.mainPanelProps.setSelectedModelId;
        if (typeof mainPanelPage.title === 'function') {
          this.mainPanel.title = mainPanelPage.title(this);
        } else {
          this.mainPanel.title = mainPanelPage.title;
        }
        this.mainPanel.platformPlus = mainPanelPage.platformPlus;
      } else {
        this.mainPanel = new this.createMainPanel[page].className(mainPanelOptions);
        this.mainPanel.action = mainPanelOptions.action;
      }

      // if we are in a details view then initialize the selected model id
      // we pass true to the setSelectedModelId to not force a rerender
      if (asideOptions) {
        createAsidePanel = true;
        // we also need to send in the asideOptions.type for directories /new url's
        // to set the selectedId appropriately
        this.mainPanel.setSelectedModelId(asideOptions.modelId || asideOptions.type);
      }
    } else if (this.mainPanel && asideOptions && (asideOptions.modelId || asideOptions.type)) {
      this.mainPanel.setSelectedModelId(asideOptions.modelId || asideOptions.type);
    } else if (this.mainPanel && !asideOptions) {
      this.mainPanel.setSelectedModelId(null);
    }

    // If we have asideOptions then we need an aside
    if (asideOptions && this.createAsidePanel[page]) {
      if (asideOptions && asideOptions.type && this.createAsidePanel[page][asideOptions.type]) {
        // Special case for #/directories/{directoryType} and where a unique
        // AsidePanelWrapper will be used for _each_ directory type (vs. a
        // single AsidePanel for all types!) and #/policies/choose(/:os)
        const data = {
          ...this.createAsidePanel[page][asideOptions.type],
          itemId: asideOptions && asideOptions.modelId,
          itemType: asideOptions && asideOptions.itemType,
          os: asideOptions.os,
          templateId: asideOptions && asideOptions.templateId,
          viewport: this.viewport,
        };

        this.asidePanel = new this
          .createAsidePanel[page][asideOptions.type]
          .AsidePanelWrapper('aside', data);
      } else if (asideOptions && asideOptions.view) {
        // Special case for asides opening other asides
        const { view } = asideOptions;
        const data = this.createAsidePanel[page][view].options(this, asideOptions);

        this.asidePanel = new this.createAsidePanel[page][view].className(data);
      } else if (this.createAsidePanel[page].asidePanelProps
          && this.createAsidePanel[page].AsidePanelWrapper) {
        // If both the props and wrapper properties are available then use the
        // Vue AsidePanel component to render the aside.

        const data = {
          ...this.createAsidePanel[page].asidePanelProps,
          itemId: asideOptions && asideOptions.modelId,
          navigateToTab: asideOptions && asideOptions.navigateToTab,
          viewport: this.viewport,
        };

        this.asidePanel = new this.createAsidePanel[page].AsidePanelWrapper('aside', data);
      } else if (this.createAsidePanel[page].options
          && this.createAsidePanel[page].AsidePanelWrapper) {
        // If both the props and wrapper properties are available then use the
        // Vue AsidePanel component to render the aside.
        const customOptions = this.createAsidePanel[page].options;
        const asidePanelOptions = customOptions(this, asideOptions);

        // Add viewport back because its absent on the asidePanelOptions object
        asidePanelOptions.viewport = this.viewport;

        this.asidePanel = new this.createAsidePanel[page].AsidePanelWrapper('aside', asidePanelOptions);
      } else {
        const customOptions = this.createAsidePanel[page].options;
        // create the options according to what page you are on
        const asidePanelOptions = customOptions ? customOptions(this, asideOptions)
          : {
            itemType: asideOptions && asideOptions.itemType,
            viewport: this.viewport,
            modelId: asideOptions && asideOptions.modelId,
          };
        this.asidePanel = new this.createAsidePanel[page].className(asidePanelOptions);
      }

      // create the asidePanel
      createAsidePanel = true;
    }

    // Finally - display appropriately

    // Load the main panel and animate the aside when necessary
    if (createMainPanel && createAsidePanel) {
      this.viewport.closeAside(() => {
        this.viewport.renderMainPanel(this.mainPanel);
        this.viewport.renderAsidePanel(this.asidePanel);
        this.viewport.openAside(this.asidePanel);
      });
    } else if (!createMainPanel && createAsidePanel) {
      this.viewport.renderAsidePanel(this.asidePanel);
      this.viewport.openAside(this.asidePanel);
    } else if (createMainPanel && !createAsidePanel) {
      this.viewport.closeAside(() => {
        this.viewport.renderMainPanel(this.mainPanel);
        delete this.asidePanel;
      });
    } else {
      this.viewport.closeAside();
    }
  },
});
